import { render, staticRenderFns } from "./TokenInfos.vue?vue&type=template&id=0ff35168&scoped=true&"
import script from "./TokenInfos.vue?vue&type=script&lang=js&"
export * from "./TokenInfos.vue?vue&type=script&lang=js&"
import style0 from "./TokenInfos.vue?vue&type=style&index=0&id=0ff35168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff35168",
  null
  
)

export default component.exports